import withCart from '../General/withCart';

class ProductPriceBase extends React.Component {
    renderBulkPricing() {
        if (this.props.product.otherPriceCollection == null) {
            return false;
        }

        var bulkPricingList = this.props.product.otherPriceCollection.filter(x => {
            if (x.bestPrice > this.props.product.bestPrice) {
                return false;
            }

            if (x.minimumQuantity <= 1) {
                return false;
            }

            return true;
        });

        bulkPricingList.sort((a, b) => {
            return a.minimumQuantity > b.minimumQuantity
        });

        bulkPricingList.reverse();

        if (bulkPricingList.length == 0) {
            return null;
        }

        return bulkPricingList.map(x => {
            return <div className="small-alt-price" key={x.minimumQuantity}>
                {x.minimumQuantity}+ ${x.bestPrice.toFixed(2)}
            </div>
        })
    }

    render() {
        if (this.props.product.bestPrice == "999999") {
            return <div className="price"></div>;
        }

        return <div>
            <div className="price">${this.props.product.bestPrice.toFixed(2)}</div>
            {this.renderBulkPricing()}
        </div>
    }
}

export const ProductPrice = withCart(ProductPriceBase);